
   <!-- <mat-dialog-content> -->

   <app-calendar [from]="fromwhere" (selectedDay)="itemSelected($event,'date')"></app-calendar>
  <app-timepicker (getSelectedTime)="itemSelected($event,'time')"></app-timepicker>
  
  <div *ngIf="isdatetimenotselected" style="color: red;padding:2px 0px 0px 9px;font-size:11px;">Please select a date and time .</div>
  <div *ngIf="isdatenotselected" style="color: red;padding:2px 0px 0px 9px;font-size:11px;">Please select a date .</div>
  <div *ngIf="istimenotselected" style="color: red;padding:2px 0px 0px 9px;font-size:11px;">Please select a time .</div>
<!-- </mat-dialog-content> -->
  <div align="end" style="font-size: 12px;">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button (click)="submitDateAndTime(dateandtime[dateandtime.length-1])" cdkFocusInitial>OK</button>
  </div>

